module.exports = __webpack_public_path__ + "img/music.84152c95.svg";